import React from "react";

import contactData from "../../data/contactData";

const Contact = ({ print = false }) => (
  <section id="contact">
    <ul>
      {contactData.map((el) => (
        <li key={el.url}>
          <a href={el.url} target="_blank" rel="noreferrer">
            <i className={el.icon} aria-hidden="true" />
            <span>{el.label}</span>
          </a>
        </li>
      ))}
    </ul>
    {print && (
      <a className="button" href="/print" target="_blank" rel="noopener noreferrer">
        Print version
      </a>
    )}
  </section>
);

export default Contact;
